/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Unlimited_Job_TrackingInputs */

const en_pricing_feature_unlimited_job_tracking = /** @type {(inputs: Pricing_Feature_Unlimited_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited job tracking`)
};

const de_pricing_feature_unlimited_job_tracking = /** @type {(inputs: Pricing_Feature_Unlimited_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenztes Stellen-Tracking`)
};

const fr_pricing_feature_unlimited_job_tracking = /** @type {(inputs: Pricing_Feature_Unlimited_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi d'emploi illimité`)
};

const es_pricing_feature_unlimited_job_tracking = /** @type {(inputs: Pricing_Feature_Unlimited_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento de empleo ilimitado`)
};

const it_pricing_feature_unlimited_job_tracking = /** @type {(inputs: Pricing_Feature_Unlimited_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracciamento lavori illimitato`)
};

const nl_pricing_feature_unlimited_job_tracking = /** @type {(inputs: Pricing_Feature_Unlimited_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbeperkt baantracking`)
};

const pl_pricing_feature_unlimited_job_tracking = /** @type {(inputs: Pricing_Feature_Unlimited_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nielimitowane śledzenie ofert pracy`)
};

const fi_pricing_feature_unlimited_job_tracking = /** @type {(inputs: Pricing_Feature_Unlimited_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rajaton työpaikan seuraaminen`)
};

const da_pricing_feature_unlimited_job_tracking = /** @type {(inputs: Pricing_Feature_Unlimited_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubegrænset jobsporing`)
};

const sv_pricing_feature_unlimited_job_tracking = /** @type {(inputs: Pricing_Feature_Unlimited_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obegränsad jobbspårning`)
};

/**
* | output |
* | --- |
* | "Unlimited job tracking" |
*
* @param {Pricing_Feature_Unlimited_Job_TrackingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_unlimited_job_tracking = /** @type {((inputs?: Pricing_Feature_Unlimited_Job_TrackingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Unlimited_Job_TrackingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_unlimited_job_tracking(inputs)
	if (locale === "fr") return fr_pricing_feature_unlimited_job_tracking(inputs)
	if (locale === "es") return es_pricing_feature_unlimited_job_tracking(inputs)
	if (locale === "it") return it_pricing_feature_unlimited_job_tracking(inputs)
	if (locale === "nl") return nl_pricing_feature_unlimited_job_tracking(inputs)
	if (locale === "pl") return pl_pricing_feature_unlimited_job_tracking(inputs)
	if (locale === "fi") return fi_pricing_feature_unlimited_job_tracking(inputs)
	if (locale === "da") return da_pricing_feature_unlimited_job_tracking(inputs)
	if (locale === "sv") return sv_pricing_feature_unlimited_job_tracking(inputs)
	return en_pricing_feature_unlimited_job_tracking(inputs)
});